import { GameArt } from "./GameArt";
import { GameBadge } from "./GameBadge";
import { Trophy, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { minScoringWords } from "@/lib/scoringWords";

export const WeekStanding = ({ week, compact = false, prefix = "game-week" }) => {
  if (!week?.week_number || !week?.standings?.length) return null;
  const me = week.standings.find(row => row.is_me);
  const allZero = week.standings.every(row => row.points === 0);
  return <section className={`game-standing ${compact ? "game-compact" : ""}`} data-testid={prefix}>
    <header className="flex items-center justify-between gap-3 mb-3">
      <h2 className="font-display text-base md:text-lg font-bold flex items-center gap-2"><Trophy size={17} className="text-tw-yellow" />Weekstand <span className="text-tw-muted">{week.week_number}</span></h2>
      {compact && <Link data-testid={`${prefix}-open`} className="text-tw-yellow text-xs inline-flex items-center gap-1" to="/weekstand">Hele stand <ArrowUpRight size={14} /></Link>}
      {!compact && <span className="text-xs text-tw-muted" data-testid={`${prefix}-deadline`}>Tot zondag</span>}
    </header>
    <p className="font-mono text-[10px] uppercase tracking-[0.15em] text-tw-muted mb-3 break-words" data-testid={`${prefix}-scoring-rule`}>
      Punten: beantwoord een vraag in minstens {minScoringWords(week)} woorden. Elke categorie telt.
      {week.focus_category && <span className="text-tw-yellow" data-testid={`${prefix}-focus`}> {week.focus_category} telt dubbel.</span>}
    </p>
    {compact ? <p className="text-sm" data-testid={`${prefix}-summary`}>
      {allZero ? "Nog niemand gescoord deze week — pak de eerste punten." : <>
      {me ? <><strong className="text-tw-yellow">{me.position}e</strong> · {me.points} {me.points === 1 ? "punt" : "punten"}</> : "Deze week"}
      <span className="text-tw-muted"> · {week.standings[0].name} staat vooraan</span>
      </>}
    </p> : <ol className="game-ranking">
      {week.standings.map(row => <li key={row.user_id} data-testid={`${prefix}-row-${row.user_id}`} className={row.is_me ? "is-me" : ""}>
        <span data-testid={`${prefix}-position-${row.user_id}`} className="game-position">{allZero ? "–" : row.position}</span>
        <span className="min-w-0 break-words" data-testid={`${prefix}-name-${row.user_id}`}>{row.name}{row.is_me && <span className="text-tw-yellow text-xs ml-2">jij</span>}</span>
        {week.last_winner_user_ids?.includes(row.user_id) && <GameBadge crown label="Winnaar vorige week" testId={`${prefix}-crown-${row.user_id}`} />}
        <strong className="game-score" data-testid={`${prefix}-points-${row.user_id}`}>{row.points}<span className="text-tw-muted text-xs font-normal ml-1">pnt</span></strong>
      </li>)}
    </ol>}
  </section>;
};

export const SeasonStanding = ({ data, prefix = "game-season" }) => {
  const season = data?.season;
  if (!season) return null;
  const slug = season.focus_category.toLowerCase().replace(/[^a-z0-9]+/g, "-");
  const allZero = data.standings.every(row => !row.weeks_won);
  return <section className="game-standing" data-testid={prefix}>
    <div className="game-season-heading">
      <GameArt src={season.art_url || `/game/season-${slug}.png`} label={season.name} testId={`${prefix}-art`} />
      <div className="relative p-5 min-w-0">
        <p className="text-xs text-tw-yellow mb-1" data-testid={`${prefix}-remaining`}>{data.weeks_left > 0 ? `${data.weeks_left} ${data.weeks_left === 1 ? "week" : "weken"} te gaan` : "Seizoen afgerond"}</p>
        <h2 className="font-display text-base md:text-lg font-bold break-words" data-testid={`${prefix}-name`}>{season.name}</h2>
        <p className="text-xs text-white mt-2" data-testid={`${prefix}-quarter`}>Gewonnen weken dit kwartaal{data.quarter_label ? ` · ${data.quarter_label}` : ""}</p>
      </div>
    </div>
    <ol className="game-ranking mt-3">
      {data.standings.map(row => <li key={row.user_id} className={row.is_me ? "is-me" : ""} data-testid={`${prefix}-row-${row.user_id}`}>
        <span className="game-position" data-testid={`${prefix}-position-${row.user_id}`}>{allZero ? "–" : row.position}</span>
        <span className="min-w-0 break-words" data-testid={`${prefix}-name-${row.user_id}`}>{row.name}{row.is_me && <span className="text-tw-yellow text-xs ml-2">jij</span>}</span>
        <strong className="game-score" data-testid={`${prefix}-wins-${row.user_id}`}>{row.weeks_won}</strong>
      </li>)}
    </ol>
  </section>;
};